module.exports = "<svg viewBox=\"0 0 19 19\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"header_menu\" fill=\"#BDBEBF\"><circle id=\"dot_b\" cx=\"10\" cy=\"16\" r=\"2\"></circle><circle id=\"dot_m\" cx=\"10\" cy=\"10\" r=\"2\"></circle><circle id=\"dot_t\" cx=\"10\" cy=\"4\" r=\"2\"></circle></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/icon_menu.svg
// module id = 3025
// module chunks = 2